import { atom } from 'recoil';

export const WarehouseUserListState = atom({
  key: 'warehouse_user_list',
  default: {
    items: [],
  },
});
